import { render, staticRenderFns } from "./titleBar_fit_iphonex.vue?vue&type=template&id=6b86a96d&scoped=true"
import script from "./titleBar_fit_iphonex.vue?vue&type=script&lang=js"
export * from "./titleBar_fit_iphonex.vue?vue&type=script&lang=js"
import style0 from "./titleBar_fit_iphonex.vue?vue&type=style&index=0&id=6b86a96d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86a96d",
  null
  
)

export default component.exports